/**
 * Row Background Color Formatter.
 * @param {*} row
 * @returns {*}
 */
window.rowBackgroundColorFormatter = function(row) {
    if (row.color) {
        return {
            css: {
                "background-color": row.color
            }
        };
    }
    return {};
};
